import axios, { AxiosPromise } from 'axios';

import { ICommodity } from '../../../@types/model/masterData/commodity/commodity';
import { ICommodityUpsert } from '../../../@types/model/masterData/commodity/commodityUpsert';

export default class CommodityHttpService {
    public static getCommodityData(onlyActive ?: boolean, ignoreIncludes ?: boolean) : AxiosPromise<Array<ICommodity>> {
        return axios.get(`${API_URL}/v1/Commodity/GetAllWeb`, {
            params : {
                ignoreIncludes,
                onlyActive,
            },
        });
    }

    public static addOrUpdateCommodity(upsert : ICommodityUpsert) : AxiosPromise<ICommodity> {
        return axios.post(`${API_URL}/v1/Commodity/PostCommodity`, upsert);
    }

    public static deleteCommodity(commodityId : number) : AxiosPromise<ICommodity> {
        return axios.delete(`${API_URL}/v1/Commodity/Delete`, {
            params : { commodityId },
        });
    }
}
